import { render, staticRenderFns } from "./ratingslist.vue?vue&type=template&id=13f7f8af&"
import script from "./ratingslist.vue?vue&type=script&lang=js&"
export * from "./ratingslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports